import { Component, OnInit } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { AdminViewComponent } from "./admin-view.component";
import { TableName } from "src/app/npr-request.model";
import { ApiService } from "src/app/services";
import { ModalService } from "src/app/shared/modal.service";
import { RegionColumnDefinitionForAdmin } from "./ag-grid-column-definition";
import { DataTypes } from "./admin-view-data-types";
import { RegionConfig } from "../../generated-models";
import { SharedDataService } from "../../services/sharedDataService";

@Component({
  standalone: false,
  selector: "admin-view/region",
  templateUrl: "./admin-view.component.html",
  styleUrls: ["../../styles.scss"],
})
export class AdminViewRegionComponent extends AdminViewComponent<RegionConfig> implements OnInit {
  type = "Region";
  tableName = TableName.Region;
  columnDef = RegionColumnDefinitionForAdmin;
  keyFilterStats = "filter:admin-view-region";

  constructor(
    apiService: ApiService,
    modalService: ModalService,
    notificationService: ToastrService,
    sharedDataService: SharedDataService,
    dataTypes: DataTypes
  ) {
    super(apiService, modalService, notificationService, sharedDataService, dataTypes);
    this.addRowEnable = true;
    this.addRowFunc = (data: RegionConfig) => apiService.setRegionConfig(data).toPromise();
    this.getDefaultValueFunc = () => apiService.getDefaultRegionConfig().toPromise();
    this.updateRowFunc = (data: RegionConfig) => apiService.setRegionConfig(data).toPromise();
    this.deleteRowEnable = true;
    this.deleteRowFunc = (data: RegionConfig) => apiService.deleteRegionConfig(data).toPromise();
  }

  refreshData() {
    super.refreshData();
    this.apiService.getRegionConfig().subscribe((response) => {
      this.setRowData(response);
      super.setupFilterByLocalData();
    });
  }
}
